import { installSimpleRankApp } from "../rank/simpleRankApp";
// 2026-10-08 に公開API (/api/ranking/simple/ivd-2025) から取得した表示内容を静的化したもの (#630)
import ranking from "../rank/data/ivd-2025.json";

const main = () => {
  installSimpleRankApp({ data: ranking });
};

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", main);
} else {
  main();
}
